export const TO_DATE = 'toDate';
export const FROM_DATE = 'fromDate';
export const EXCEL_FORMAT_TYPE='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const MIS_ORDER_DATA_DEFAULT_FILE_NAME='MisOrderData';
export const INVALID_DATE_RANGE_MSG="Please enter valid date range, From date should be before To date!!!!!!";
export const DATE_FORMAT='dd-MM-yyyy';
export const MIS_ORDER_GENERATION_SUCCESS_MSG='Mis Order data for the given date range Generated Successfully!!!'
export const INTERNAL_SERVER_ERROR_MSG='Something went Wrong !!! Please try again later'